import React, { useEffect, useState } from "react";

export default function IntroScreen({ onComplete }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 300);
    const t2 = setTimeout(() => setPhase(2), 1200);
    const t3 = setTimeout(() => setPhase(3), 2000);
    const t4 = setTimeout(() => onComplete(), 2800);
    return () => [t1, t2, t3, t4].forEach(clearTimeout);
  }, [onComplete]);

  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "#0a0f1e",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        zIndex: 9999, transition: "opacity 0.6s ease",
        opacity: phase === 3 ? 0 : 1, pointerEvents: phase === 3 ? "none" : "all",
      }}
    >
      {/* Animated background orbs */}
      <div style={{ position: "absolute", inset: 0, overflow: "hidden" }}>
        {[...Array(3)].map((_, i) => (
          <div key={i} style={{
            position: "absolute",
            width: `${200 + i * 100}px`, height: `${200 + i * 100}px`,
            borderRadius: "50%",
            background: i === 0 ? "radial-gradient(circle, rgba(99,102,241,0.3) 0%, transparent 70%)"
              : i === 1 ? "radial-gradient(circle, rgba(16,185,129,0.2) 0%, transparent 70%)"
              : "radial-gradient(circle, rgba(245,158,11,0.15) 0%, transparent 70%)",
            left: i === 0 ? "20%" : i === 1 ? "60%" : "40%",
            top: i === 0 ? "20%" : i === 1 ? "60%" : "40%",
            transform: "translate(-50%, -50%)",
            animation: `pulse ${2 + i * 0.5}s ease-in-out infinite alternate`,
          }} />
        ))}
      </div>

      {/* Logo icon */}
      <div style={{
        width: 80, height: 80, borderRadius: 20,
        background: "linear-gradient(135deg, #6366f1, #10b981)",
        display: "flex", alignItems: "center", justifyContent: "center",
        marginBottom: 24,
        transform: phase >= 1 ? "scale(1) translateY(0)" : "scale(0.5) translateY(20px)",
        opacity: phase >= 1 ? 1 : 0,
        transition: "all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)",
        boxShadow: "0 0 40px rgba(99,102,241,0.4)",
      }}>
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>

      {/* Title */}
      <div style={{
        transform: phase >= 1 ? "translateY(0)" : "translateY(30px)",
        opacity: phase >= 1 ? 1 : 0,
        transition: "all 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s",
        textAlign: "center",
      }}>
        <h1 style={{
          fontSize: "clamp(2rem, 5vw, 3.5rem)",
          fontFamily: "'Georgia', serif",
          fontWeight: 700,
          letterSpacing: "-0.02em",
          background: "linear-gradient(135deg, #fff 0%, #a5b4fc 50%, #6ee7b7 100%)",
          WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          margin: 0, lineHeight: 1.1,
        }}>Finance Dashboard</h1>
        <p style={{
          color: "rgba(255,255,255,0.5)",
          fontSize: "1.1rem", fontFamily: "'Georgia', serif",
          marginTop: 8, letterSpacing: "0.15em", textTransform: "uppercase",
          transform: phase >= 2 ? "translateY(0)" : "translateY(10px)",
          opacity: phase >= 2 ? 1 : 0,
          transition: "all 0.5s ease 0.2s",
        }}>Track · Analyze · Grow</p>
      </div>

      {/* Loading bar */}
      <div style={{
        marginTop: 48, width: 200, height: 2,
        background: "rgba(255,255,255,0.1)", borderRadius: 1, overflow: "hidden",
        opacity: phase >= 1 ? 1 : 0, transition: "opacity 0.3s ease 0.3s",
      }}>
        <div style={{
          height: "100%",
          background: "linear-gradient(90deg, #6366f1, #10b981)",
          borderRadius: 1,
          width: phase >= 2 ? "100%" : "0%",
          transition: "width 0.8s ease",
        }} />
      </div>

      <style>{`
        @keyframes pulse {
          from { transform: translate(-50%, -50%) scale(1); }
          to { transform: translate(-50%, -50%) scale(1.2); }
        }
      `}</style>
    </div>
  );
}
